import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';

import useGlobal from '../../../../store';
import UsuarioRolesForm from './UsuarioRolesForm';
import UsuarioPermissionsForm from './UsuarioPermissionsForm';

const mapState = (state) => {
  return { ...state.app.usuarios.upsert };
};

const mapActions = (actions) => {
  return { ...actions.app.usuarios.upsert };
};

const UsuarioPermissionsCreate = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const { data } = state;

  const handleOnChange = (values) => {
    const newData = {
      isValid: true,
      ...state,
      data: {
        ...data,
        ...values,
      },
    };

    actions.change(newData);
  };

  const handleOnDeselectionClick = () => {
    handleOnChange({
      selected: {},
    });
  };

  return (
    <>
      <h5>Gestión de permisos</h5>

      <Row>
        <Col>
          <div className="py-3">
            <strong className="text-info">ROLES</strong>
          </div>

          <UsuarioRolesForm
            role={data.role}
            onChange={handleOnChange}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <div className="py-3">
            <strong className="text-info">PERMISOS</strong>
          </div>

          <div className="pb-3">
            <Button
              variant="secondary"
              onClick={handleOnDeselectionClick}
            >
              Deseleccionar todos los permisos
            </Button>
          </div>

          <UsuarioPermissionsForm
            selected={data.selected || {}}
            onClean={() => {}}
            onChange={handleOnChange}
          />
        </Col>
      </Row>
    </>
  );
};

export default UsuarioPermissionsCreate;
